import React from 'react';
const _ = {
    find:       require('lodash/find'),
    forEach:    require('lodash/forEach'),
    map:        require('lodash/map'),
};

const Strings = require('../../../../app/shared/Strings');

import AccessibleIcon from '../common/AccessibleIcon';
import CoachConditionsLine from './CoachConditionsLine';

function CoachScriptActionEditor({
        coachAction,
        doUpdate,
        richTextList,
        stickerList,
        actionIndex,
        doEditCoachText,
        doMoveUp,
        doMoveDown,
        doDeleteAction,
        doChangeAdditionalCheckbox,prior_showAdditionalRemedialSkills,
        doChangeActivityElementsCheckbox,prior_showActivityElements,
        toggleConditionsEditor,conditionsExpanded,onChangeConditions,
    }) {
    const richTextEntry = _.find(richTextList,{id:coachAction.rich_text_id});
    const isCommonText = richTextEntry && !richTextEntry.coach_script_id;
    const editTitle = isCommonText ? "edit common rich text" : "edit rich text for this action";
    
    let stickerEntry = _.find(stickerList,{id:coachAction.coach_sticker_id});
    let stickerSrc = stickerEntry && stickerEntry.src;
    if (stickerSrc) {
        stickerSrc = stickerSrc.replace(/^\$ASSET_PREFIX/, GlobalConfig.AssetStoreUrl);
    }
    
    switch(coachAction.type) {
        case 'showRichText':
            return (
                <div className="coach-action-editor">
                    <label className="coach-action-label">{`Action ${actionIndex+1}:`}</label>
                    <span className="edit-selector">
                        <label>{'Show Rich Text:'}</label>
                        <select className="rich-text-dropdown" value={coachAction.rich_text_id} onChange={(e)=>{doUpdate({rich_text_id:e.target.value})}}>
                            {_.map(richTextList,(entry,k)=>(
                                <option key={k} value={entry.id}>{entry.displayName}</option>
                            ))}
                            <option key={'add'} value={'add'}>{'Add Rich Text'}</option>
                        </select>
                        <span className="coach-script-control-buttons">
                            <button title={editTitle} disabled={!richTextEntry} onClick={doEditCoachText}>
                                <AccessibleIcon className="fa fa-pencil" label={editTitle}/> 
                            </button>
                        </span>
                    </span>
                    <span className="edit-selector show-child-on-hover">
                        {stickerSrc ? <img className="show-on-hover" src={stickerSrc}/> : null }
                        <label>{'Pose:'}</label>
                        <select className="coach-sticker-dropdown" value={coachAction.coach_sticker_id || ''} onChange={(e)=>{doUpdate({coach_sticker_id:e.target.value})}}>
                            {_.map(stickerList,(entry,k)=>(
                                <option key={k} value={entry.id}>{entry.displayName}</option>
                            ))}
                            <option key='none' value="">{'None'}</option>
                        </select>
                    </span>
                    <CoachConditionsLine 
                        conditions={coachAction.conditions}
                        onChangeConditions={onChangeConditions}
                        expanded={conditionsExpanded}
                        toggleExpanded={toggleConditionsEditor}
                    />
                    <span className="coach-script-control-buttons">
                        <button title="move up" onClick={doMoveUp} disabled={!doMoveUp}>
                            <AccessibleIcon className="fa fa-caret-up" label="move up"/>
                        </button>
                        <button title="move down" onClick={doMoveDown} disabled={!doMoveDown}>
                            <AccessibleIcon className="fa fa-caret-down" label="move down"/>
                        </button>
                        {doDeleteAction ? 
                        <button title="delete" onClick={doDeleteAction}>
                            <AccessibleIcon className="fa fa-trash" label="delete action"/>
                        </button>
                        : null }
                    </span>
                    { doChangeAdditionalCheckbox ? 
                    <span className="edit-selector">
                        <input type="checkbox" onChange={doChangeAdditionalCheckbox} 
                            disabled={prior_showAdditionalRemedialSkills}
                            checked={!prior_showAdditionalRemedialSkills && !!coachAction.showAdditionalRemedialSkills}/>
                        <label>{'Show Additional Remediation'}</label>
                    </span>
                    : null }
                    { doChangeActivityElementsCheckbox ? 
                    <span className="edit-selector">
                        <input type="checkbox" onChange={doChangeActivityElementsCheckbox}
                            disabled={prior_showActivityElements}
                            checked={!prior_showActivityElements && !!coachAction.showActivityElements}/>
                        <label>{'Show Activity Information'}</label>
                    </span>
                    : null }
                </div>
            )
        default:
            console.log("unknown coach action type",coachAction.type);
            break;
    }
    return null;
} //CoachScriptActionEditor

export default CoachScriptActionEditor;